
<mat-card class="menupannel">
  <div class="resUser">
    <button mat-flat-button (click)="showMyDrive()">
      <mat-icon>menu</mat-icon> My Drive 
    </button>
  </div>
  <div class="d">   
  </div>
</mat-card>

<div class="coreholder" fxLayout="row">    

  <mat-card class="myDrive" [ngClass]="{ open: showmyDrive }">
    <app-left-menu></app-left-menu>
  </mat-card>

  <div class="myDriveOverlay"
    (click)="showMyDrive()"
    [ngClass]="{ open: showmyDrive }">
  </div>

  
  <div class="corepages"> 
    <mat-card class="filter">
      <label>Draft</label>
      <div class="slAct">
      
        <button *ngIf="SelectedRecordForDeleFav" (click)="deleteDraftProjects()" mat-icon-button><mat-icon>delete_outline</mat-icon></button>
      </div>
      <div class="projectSearch">
      
        <button class="searchbtn" [disabled]="pageModelData.searchValue==''"  mat-icon-button aria-label="Clear">
          <mat-icon (click)="SearchFilter()">search</mat-icon>
        </button>
       
        <input placeholder="Search Draft" type="text"  maxlength="30" [(ngModel)]="pageModelData.searchValue" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />
                  
        </div>
      <!-- <mat-form-field appearance="">
        <mat-label>Search... </mat-label>
        <input matInput type="text"  maxlength="30" [(ngModel)]="pageModelData.searchValue" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />
        <button [disabled]="pageModelData.searchValue==''" matSuffix mat-icon-button aria-label="Clear">
          <mat-icon (click)="SearchFilter()">search</mat-icon>
        </button>
      </mat-form-field> -->
     

      <div class="add">
        <button mat-button color="primary" [matMenuTriggerFor]="menu"><mat-icon>add</mat-icon> Create</button>
        <mat-menu #menu="matMenu">
        <button mat-menu-item  (click)="CreatePdfForm(true)">PDF Form</button>
        <button mat-menu-item  (click)="CreateAuditForm(true)">Tabular Form</button>
        <button mat-menu-item  (click)="CreateHTMLForm(true)">HTML Form</button>
        <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreatePdfForm(false)">Master PDF Form</button>
        <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreateAuditForm(false)">Master Tabular Form</button>
        <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreateHTMLForm(false)">Master Web Form</button>
      </mat-menu>       
      </div>
      
    </mat-card>
    

    <mat-card class="emailList">
     
      <mat-table class="zui-table" [dataSource]="dataSource" matSort matSortDisableClear matSortDirection="asc">
        <ng-container matColumnDef="projectId">
          <div *matHeaderCellDef class="check" >
             <mat-checkbox color="primary" [disabled]="noRecordFound"
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"></mat-checkbox>
          </div>
          <div *matCellDef="let draft" class="check">
            <mat-checkbox color="primary" (change)="isAllSelectedRow($event,draft)"
            (change)="$event ? selection.toggle(draft) : null"
            [checked]="selection.isSelected(draft)"></mat-checkbox>
          </div>
        </ng-container>

        <ng-container matColumnDef="projectType">
        <div class="action" *matHeaderCellDef>
          Type
        </div>
        <div class="action" *matCellDef="let draft">    
           <!-- <img *ngIf="draft.projectType != 2" src="../../../../assets/images/icons/formIcon.svg" alt="" width="30"/> -->
           <app-doc-icons *ngIf="draft.projectType != 2" [iconType]="'FORM'"></app-doc-icons>
           <app-doc-icons *ngIf="draft.projectType == 2" [iconType]="'TABULAR'"></app-doc-icons>
           <!-- <img *ngIf="draft.projectType == 2" src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="30"/>          -->
        </div>
        </ng-container>

        <ng-container matColumnDef="projectName">
          <div *matHeaderCellDef mat-sort-header class="subject">
            Project Name
          </div>

          <div *matCellDef="let draft" class="subject">
            <h4 *ngIf="draft.projectType!= 2" matTooltip="{{ draft.projectName }}" (click)="OpenProjectDeatils(draft)">{{ draft.projectName }}</h4>
            <h4 *ngIf="draft.projectType== 2" matTooltip="{{ draft.projectName }}" (click)="OpenTablarDeatils(draft)">{{ draft.projectName }}</h4> 
          </div>
        </ng-container>


  

        <ng-container matColumnDef="stepCompleted">
          <div *matHeaderCellDef mat-sort-header class="stepCompleted">
            Steps
          </div>

          <div *matCellDef="let draft" class="stepCompleted">
            <p class="showSteps" *ngIf="draft.projectType!= 2">
              <ng-container *ngIf="draft.stepCompleted == 0 || draft.stepCompleted == 1">
                <span class="active"></span>
                <span></span>
                <span></span>
                <span></span>
              </ng-container>
              <ng-container *ngIf="draft.stepCompleted == 2">
                <span class="active"></span>
                <span class="active"></span>
                <span></span>
                <span></span>
              </ng-container>
              <ng-container *ngIf="draft.stepCompleted == 3">
                <span class="active"></span>
                <span class="active"></span>
                <span class="active"></span>
                <span></span>
              </ng-container>
              <ng-container *ngIf="draft.stepCompleted == 4">
                <span class="active"></span>
                <span class="active"></span>
                <span class="active"></span>
                <span class="active"></span>
              </ng-container>                         

            </p>
          
            <p class="showSteps" *ngIf="draft.projectType== 2">
              <ng-container>
                <span class="active"></span>
                <span class="active"></span>             
              </ng-container>                                     
            </p>
          </div>
         
        </ng-container>

        
        <ng-container matColumnDef="createdOn">
          <div *matHeaderCellDef mat-sort-header class="createdon sepDateTime"> Created On </div>
          <p *matCellDef="let draft" class="createdon sepDateTime"> 
            <span> {{ draft.createdOn+'Z' | date: "MM/dd/yyyy"}}</span>
            <!-- <span class="time" >{{ draft.createdOn | date: "h:mm a"}}</span> -->
            <span class="time">{{ draft.createdOn+'Z' | date: "h:mm a" }}</span>
           </p>
        </ng-container>

        <ng-container matColumnDef="updatedOn">
          <div *matHeaderCellDef mat-sort-header class="createdon sepDateTime"> Modified On </div>
          <p *matCellDef="let draft" class="createdon sepDateTime"> 
           <span> {{ ValidateDate(draft.updatedOn) | date: "MM/dd/yyyy"}}</span>
           <!-- <span class="time" >{{ ValidateDate(draft.updatedOn) | date: "h:mm a"}}</span> -->
           <span class="time" >{{ ValidateDate(draft.updatedOn+'Z') | date: "h:mm a"}}</span>
          </p>
        </ng-container>
        
<ng-container matColumnDef="action">
  <div class="action" *matHeaderCellDef>Action</div>

  <div class="action" *matCellDef="let draft">    
    <!-- Keep Open & Continue outside -->
    <button *ngIf="draft.projectType != 2"
            mat-icon-button 
            color="basic" 
            matTooltipClass="tooltip" 
            matTooltip="Open & Continue" 
            (click)="OpenProjectDeatils(draft)">
      <mat-icon>open_in_new</mat-icon>
    </button>  

    <button *ngIf="draft.projectType == 2"
            mat-icon-button 
            color="basic" 
            matTooltipClass="tooltip" 
            matTooltip="Open & Continue" 
            (click)="OpenTablarDeatils(draft)">
      <mat-icon>open_in_new</mat-icon>
    </button>  

<button 
  *ngIf="draft.projectType != 2"
  mat-icon-button
  class="more-btn"
  matTooltip="Action not available"
  [disabled]="true">
  <mat-icon>more_vert</mat-icon>
</button>


    <!-- More menu -->
    <button *ngIf="draft.projectType == 2" mat-icon-button [matMenuTriggerFor]="menu" class="more-btn">
      <mat-icon>more_vert</mat-icon>
    </button>

    <!-- Menu Content -->
    <mat-menu #menu="matMenu">
      <button *ngIf="draft.projectType == 2" mat-menu-item (click)="viewProjectDetails(draft)">
        <mat-icon>visibility</mat-icon>
        <span>View Docs</span>
      </button>
   
      <button *ngIf="draft.projectType == 2" mat-menu-item (click)="editProject(draft)">
        <mat-icon>edit</mat-icon>
        <span>Edit Project</span>
      </button>

      <button *ngIf="draft.projectType == 2" mat-menu-item (click)="copyProjectUrl(draft)">
        <mat-icon>content_copy</mat-icon>
        <span>Copy URL</span>
      </button>

      <button *ngIf="draft.projectType == 2" mat-menu-item (click)="deleteDraftedProject(draft.projectID)">
        <mat-icon>delete_outline</mat-icon>
        <span>Delete</span>
      </button>
    </mat-menu>
  </div>
</ng-container>
>

        <mat-header-row  class="list ehead"  *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row  class="list erow" *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <div *ngIf="noRecordFound" class="noRecordFound">No Record Found</div>
      
      <mat-paginator  *ngIf="!noRecordFound" [length]="paginatorTotalLength"
        [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 30]"
        itemsPerPageLabel="Records Per Page" showFirstLastButtons
        (page)="pageEventPropogate($event)">
    </mat-paginator>
    </mat-card> 
   
  </div>

 

  <!-- Document Detail  -->
<mat-card class="documentDetail" [ngClass]="{ open: docDetail }">
  <file-doc-detail [fileItems]="fileItemsList"></file-doc-detail>
</mat-card>


  <div class="documentDetailOverlay"
   
    [ngClass]="{ open: docDetail }">
  </div>

  <!-- Document Detail -->
</div>
